import { IUser } from "services/types";
import "./CollectionsHeader.scss";
import { BackButton, PlusButton } from "../buttons";
import { routes } from "routes";

export const CollectionsHeader = (props: {
  user: IUser;
  editable: boolean;
  onCreate: () => void;
}): JSX.Element => {
  const onClick = () => {
    if (props.onCreate) {
      props.onCreate();
    } else {
      console.warn("The onClick property not set for CollectionsHeader.");
    }
  };

  return (
    <div className="collectionsHeader">
      <BackButton
        link={routes.user(props.user.username)}
      />

      {props.editable ? (
        <h2 className="header">Saved</h2>
      ) : (
        <h2 className="header">Collections by {props.user.name ?? props.user.username}</h2>
      )}

      {props.editable && <PlusButton
        onClick={onClick}
        hint="Create a new collection"
      />}
    </div>
  );
};
